/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IrrJobTypeEnum } from './irrJobTypeEnum';


/**
 * Contains arguments and metadata for invoking cloudrun job
 */
export interface GcpInvokeCloudRunJobSpec { 
    container_image_name: string;
    irr_id: string;
    /**
     * Cloud run job name.
     */
    job_name: string;
    job_type: IrrJobTypeEnum;
    /**
     * Metadata for CloudRun job
     */
    metadata?: { [key: string]: string; };
    zone: string;
}
export namespace GcpInvokeCloudRunJobSpec {
}


